export default "__VITE_ASSET__ad8bcf39__"